var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-lock-02",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M21.76 14.72v-3.84c0-3.535-2.865-6.4-6.4-6.4s-6.4 2.865-6.4 6.4v3.84M9.984 27.52h10.752c2.151 0 3.226 0 4.047-0.419 0.723-0.368 1.31-0.956 1.678-1.678 0.419-0.822 0.419-1.897 0.419-4.047v-0.512c0-2.151 0-3.226-0.419-4.047-0.368-0.723-0.956-1.31-1.678-1.678-0.822-0.419-1.897-0.419-4.047-0.419h-10.752c-2.151 0-3.226 0-4.047 0.419-0.723 0.368-1.31 0.956-1.678 1.678-0.419 0.822-0.419 1.897-0.419 4.047v0.512c0 2.151 0 3.226 0.419 4.047 0.368 0.723 0.956 1.31 1.678 1.678 0.821 0.419 1.897 0.419 4.047 0.419z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-mail-01",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M2.56 9.6l10.451 7.316c0.846 0.593 1.27 0.889 1.73 1.003 0.407 0.101 0.832 0.101 1.238 0 0.46-0.115 0.883-0.411 1.73-1.003l10.451-7.316M8.704 26.24h13.312c2.151 0 3.226 0 4.047-0.419 0.723-0.368 1.31-0.956 1.678-1.678 0.419-0.822 0.419-1.897 0.419-4.047v-8.192c0-2.151 0-3.226-0.419-4.047-0.368-0.723-0.956-1.31-1.678-1.678-0.822-0.419-1.897-0.419-4.047-0.419h-13.312c-2.151 0-3.226 0-4.047 0.419-0.723 0.368-1.31 0.956-1.678 1.678-0.419 0.821-0.419 1.897-0.419 4.047v8.192c0 2.151 0 3.226 0.419 4.047 0.368 0.723 0.956 1.31 1.678 1.678 0.821 0.419 1.897 0.419 4.047 0.419z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-01",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M25.6 27.52c0-1.786 0-2.679-0.22-3.406-0.496-1.636-1.777-2.917-3.413-3.413-0.727-0.22-1.62-0.22-3.406-0.22h-6.4c-1.786 0-2.679 0-3.406 0.22-1.636 0.496-2.917 1.777-3.413 3.413-0.22 0.727-0.22 1.62-0.22 3.406M21.12 10.24c0 3.181-2.579 5.76-5.76 5.76s-5.76-2.579-5.76-5.76c0-3.181 2.579-5.76 5.76-5.76s5.76 2.579 5.76 5.76z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.6667 5.49998V4.76665C14.6667 3.73988 14.6667 3.2265 14.4668 2.83433C14.2911 2.48937 14.0106 2.2089 13.6656 2.03313C13.2735 1.83331 12.7601 1.83331 11.7333 1.83331H10.2667C9.2399 1.83331 8.72652 1.83331 8.33435 2.03313C7.98939 2.2089 7.70892 2.48937 7.53315 2.83433C7.33333 3.2265 7.33333 3.73988 7.33333 4.76665V5.49998M9.16667 10.5416V15.125M12.8333 10.5416V15.125M2.75 5.49998H19.25M17.4167 5.49998V15.7666C17.4167 17.3068 17.4167 18.0769 17.1169 18.6651C16.8533 19.1826 16.4326 19.6033 15.9151 19.8669C15.3269 20.1666 14.5568 20.1666 13.0167 20.1666H8.98333C7.44319 20.1666 6.67312 20.1666 6.08486 19.8669C5.56741 19.6033 5.14672 19.1826 4.88307 18.6651C4.58333 18.0769 4.58333 17.3068 4.58333 15.7666V5.49998"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cross",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4,
    d: "M25 7l-18 18"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4,
    d: "M25 25l-18-18"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "logo",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3.10251V8.55613V8.66613V8.55613C3 10.1133 3.67941 11.4919 4.73282 12.3842C5.24788 12.8205 5.58824 13.4096 5.58824 14.0635V23.1667C5.58824 24.1788 6.45788 25.0001 7.52941 25.0001C8.60094 25.0001 9.47059 24.1788 9.47059 23.1667V14.0635C9.47059 13.4096 9.81094 12.8205 10.326 12.3842C11.3794 11.4919 12.0588 10.1133 12.0588 8.55613V3.10251V8.55613",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5293 9.11118V3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 4.28544C24.9999 3.61076 24.4201 3.0632 23.7058 3.0632H22.4116C20.2673 3.0632 18.5293 4.70467 18.5293 6.72991V14.0633C18.5293 15.6571 19.6125 17.0004 21.1175 17.5052V23.1666C21.1175 24.1786 21.9872 24.9999 23.0587 24.9999C24.1302 24.9999 24.9999 24.1786 24.9999 23.1666V17.73V4.28544Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left",
    viewBox: "0 0 8 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64471 0.394637C7.75733 0.518919 7.84669 0.666543 7.90765 0.829057C7.96862 0.991571 8 1.16579 8 1.34173C8 1.51767 7.96862 1.69188 7.90765 1.8544C7.84669 2.01691 7.75733 2.16454 7.64471 2.28882L2.93089 7.50117L7.64471 12.7135C7.87187 12.9647 7.99949 13.3054 7.99949 13.6606C7.99949 14.0158 7.87187 14.3565 7.64471 14.6077C7.41755 14.8589 7.10945 15 6.7882 15C6.46695 15 6.15886 14.8589 5.9317 14.6077L0.35529 8.44154C0.242664 8.31726 0.153311 8.16964 0.0923452 8.00712C0.0313797 7.84461 0 7.67039 0 7.49445C0 7.31851 0.0313797 7.1443 0.0923452 6.98178C0.153311 6.81927 0.242664 6.67165 0.35529 6.54736L5.9317 0.381203C6.39336 -0.129285 7.1709 -0.129285 7.64471 0.394637Z",
    fillOpacity: 0.73
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right",
    viewBox: "0 0 8 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.355291 0.394637C0.242666 0.518919 0.153312 0.666543 0.0923468 0.829057C0.0313812 0.991571 0 1.16579 0 1.34173C0 1.51767 0.0313812 1.69188 0.0923468 1.8544C0.153312 2.01691 0.242666 2.16454 0.355291 2.28882L5.06911 7.50117L0.355291 12.7135C0.128132 12.9647 0.000514428 13.3054 0.000514428 13.6606C0.000514428 14.0158 0.128132 14.3565 0.355291 14.6077C0.582451 14.8589 0.890546 15 1.2118 15C1.53305 15 1.84114 14.8589 2.0683 14.6077L7.64471 8.44154C7.75734 8.31726 7.84669 8.16964 7.90765 8.00712C7.96862 7.84461 8 7.6704 8 7.49445C8 7.31851 7.96862 7.1443 7.90765 6.98178C7.84669 6.81927 7.75734 6.67165 7.64471 6.54736L2.0683 0.381203C1.60664 -0.129285 0.829104 -0.129285 0.355291 0.394637Z",
    fillOpacity: 0.73
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "motivation-bg",
    viewBox: "0 0 268 242"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.100829 47.0671C0.100887 36.2375 0.415993 16.7442 3.74393 10.4131C9.41112 -0.368316 24.4852 0.289637 36.652 0.859711L238.71 10.3271C239.93 10.3843 241.143 10.5515 242.334 10.8266C254.38 13.61 263.631 23.317 265.868 35.4765C267.284 43.1735 268 50.9894 268 58.8156V171.171C268 180.059 264.933 188.698 259.316 195.587C254.282 201.763 246.743 205.346 238.776 205.346H192.705C191.583 205.346 190.261 205.539 188.853 205.856C180.406 207.756 173.788 213.98 168.633 220.936C167.489 222.481 166.227 223.932 164.936 225.357C158.976 231.938 151.013 242 133.634 242C127.855 242 122.519 240.359 118.186 238.299C111.305 235.027 106.409 228.914 101.903 222.771C94.0396 212.049 80.8993 206.67 67.6262 207.456C53.5009 208.291 36.7947 208.233 24.6443 205.346C5.00947 200.681 -0.869851 175.217 0.100829 163.694V47.0671Z",
    fillOpacity: 0.338
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "motivation-close",
    viewBox: "0 0 28 28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8332 8.16666L8.1665 19.8333M8.1665 8.16666L19.8332 19.8333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.495d7d4d6a1627dfbe031a7af658a0f6.svg";
export { ForwardRef as ReactComponent };